<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>
  <div class="cointainer" style="margin-top: 20px; margin-bottom: 5px;">
  <div class="right-cointainer" style="margin: 0 0 0 auto;">
    <p>Łódź, dnia {{datazdnia}} r. <br>
</p>
  </div>
</div>
<div class="cointainer" style="margin-top: 20px; margin-bottom: 5px;">
  <div class="right-cointainer" style="margin: 0 0 0 70%;">
    <p>Imię i nazwisko: {{imieNazwisko}}   <br>
    PESEL: {{pesel}}
    
</p>
  </div>
</div>

<p align="center" style="margin-top:20px;">
    <strong>INFORMACJA dot. monitoringu zajęć online</strong>
<p>
<ol>
<li>
Na podstawie art. 6 ust. 1 pkt. f Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób 
fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE 
(ogólne rozporządzenie o ochronie danych) oraz art. 223 § 1 i 4 Kodeksu pracy dotyczących inny form monitoringu w zakładzie pracy funkcjonuje 
szczególny nadzór nad zajęciami prowadzonymi w trybie online przez zleceniobiorców prowadzących zajęcia z klientem zewnętrznym Tutore Poland Sp. z o.o. 
</li>
<li>
Monitoring występuje w postaci środków technicznych umożliwiających rejestrację nagrań audiowizualnych i dźwiękowych wyłącznie w trakcie
przeprowadzanych zajęć online (zwane dalej nagraniami zajęć online). Administratorem danych osobowych uzyskanych na nagraniach monitoringu 
zajęć online jest Tutore Poland Sp. z o.o. 
</li>
<li>
Celem monitoringu jest zapewnienia najwyższych standardów obsługi zajeć lekcyjnych realizowanej przez zleceniobiorców, prawidłowości wykonywania 
powierzonych czynności oraz poprawienia jakości lekcji, a w szczególności w sytuacjach spornych powstałych pomiędzy klientem zewnętrznym, 
kontrahentem czy osobą wykonującą czynności na rzecz Tutore Poland Sp. z o.o., a zleceniobiorcą.
</li>
<li>
Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online przez Platformę 
Clickmeeting bądź Zoom, znajdujące się w posiadaniu użytkownika. Użytkownik na platformie Zoom każdorazowo wyraża zgodę na jego nagrywanie
przed rozpoczęciem zajęć.
</li>
<li>
Nagrania zajęć online są przetwarzane tylko do celów określonych powyżej i przechowuje się co do zasady przez okres do 12 miesięcy. W przypadku, 
w którym nagrania zarejestrowanych zajęć online stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Zleceniodawca powziął wiadomość,
iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. 
Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu.
</li>
<li>
Zakres sposobu zastosowania monitoringu audiowizualnego i dźwiękowego zajęć online: 
</li>
<ol type="a">
<li>
System monitoringu  audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, 
na którym są zapisywane zajęcia online;
</li>
<li>
Dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj, Manager Działu Call Center, Dyrektor ds. Zarządzania 
Procesami, Teamleader Działu Infolinii, a w sytuacjach uzasadnionych zleceniobiorca za zgodą zleceniodawcy lub klient zewnętrzny. 
</li>
<li>
Osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne 
upoważnienie wydane przez administratora danych.
</li>
</ol>
<li>Prawo do ustalenia bądź zmiany hasła dostępu systemu monitoringu mają tylko Zarząd Tutore Poland Sp. z o.o. i osoby uprawnione przez 
  Zarząd tj. Dyrektor ds. Zarządzania Procesami.</li>
</ol>
</p>

<div class="cointainer" style="margin-top: 5px; margin-bottom: 0px;">


  <div class="right-cointainer" style="margin: 0 0 0 auto;">
    <p>Otrzymałam/em <br>
      i wyrażam zgodę
</p>
    
  </div>
</div>
</td></tr>
</tbody></table>
  </v-container>
</template>

<script>
export default {
  name: 'UmowaMonitoring',
  props: {
    zamawiajacyProp: {
      type: String,
      default: undefined
    },
    imieNazwiskoProp: {
      type: String,
      default: undefined
    },
    zamieszkanyProp: {
      type: String,
      default: undefined
    },
    peselProp: {
      type: String,
      default: undefined
    },
    datazdniaProp: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      existingProps: [
        'zamawiajacy',
        'imieNazwisko',
        'zamieszkany',
        'pesel',
        'datazdnia'
      ],
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      pesel: '',
      datazdnia: ''
    }
  },
  created () {
    for (const existingProp of this.existingProps) {
      if (this[`${existingProp}Prop`]) {
        this[existingProp] = this[`${existingProp}Prop`]
      } else {
        this[existingProp] = this.$route.query[existingProp]
      }
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
.page {
  size: 210mm 290mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaMonitoring.vue